import { useOffsetCalculator } from './hooks/useOffsetCalculator';
import { useHistory } from './hooks/useHistory';
import { useDarkMode } from './hooks/useDarkMode';
import { ThemeToggle } from './components/ThemeToggle';
import { PresetterSelector } from './components/PresetterSelector';
import { BinaryInputGrid } from './components/BinaryInputGrid';
import { TestCutInputs } from './components/TestCutInputs';
import { ResultDisplay } from './components/ResultDisplay';
import { HistoryPanel } from './components/HistoryPanel';

function App() {
  const { isDark, toggleTheme } = useDarkMode();
  const {
    mode,
    setMode,
    bytes,
    setBit,
    cncDiameter,
    setCncDiameter,
    measuredDiameter,
    setMeasuredDiameter,
    originalOffset,
    result,
    state,
    prefillBytes23,
    clearAll,
    loadFromHistory
  } = useOffsetCalculator();

  const { history, addEntry, removeEntry, clearHistory } = useHistory();

  const handleSaveToHistory = () => {
    if (result) {
      addEntry(state, result);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">
              MoriSeiki Presetter
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Probe Setter Offset Calculator
            </p>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={clearAll}
              className="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md transition-colors"
            >
              Clear All
            </button>
            <ThemeToggle isDark={isDark} onToggle={toggleTheme} />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column - Inputs */}
          <div className="lg:col-span-2 space-y-6">
            <PresetterSelector mode={mode} onModeChange={setMode} />

            <BinaryInputGrid
              mode={mode}
              bytes={bytes}
              onBitChange={setBit}
              onPrefill={prefillBytes23}
              originalOffset={originalOffset}
            />

            <TestCutInputs
              cncDiameter={cncDiameter}
              measuredDiameter={measuredDiameter}
              onCncChange={setCncDiameter}
              onMeasuredChange={setMeasuredDiameter}
              error={result?.error ?? null}
            />

            <ResultDisplay
              mode={mode}
              result={result}
              onSaveToHistory={handleSaveToHistory}
            />
          </div>

          {/* Right Column - History */}
          <div className="lg:col-span-1">
            <HistoryPanel
              history={history}
              onLoadEntry={loadFromHistory}
              onRemoveEntry={removeEntry}
              onClearHistory={clearHistory}
            />
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="mt-8 py-4 text-center text-sm text-gray-500 dark:text-gray-400">
        MoriSeiki Presetter Calculator
      </footer>
    </div>
  );
}

export default App;
